module.exports = __webpack_public_path__ + "static/img/266.0170ce52.gif";